
import { ResultData } from "@nt-portal/common-sdk";
import { BaseClientService } from "../base-client.service";
import { DocImportRunService } from "@nt-portal/doc-agent-sdk";
import { ControllerOptions, DataController } from "../../../types";
import { DocImportRun } from "@nt-portal/doc-agent-sdk";

export interface DocImportRunOptions extends ControllerOptions<DocImportRun> {
    bidId?: string;
    status?: string[];
    startDate?: Date;
    endDate?: Date;
}

export const initDocImportRun = () => {
    let item: DocImportRun = {
        userId: "",
        status: "",
        name: "",
        createdBy: "",
        actionOptions: [],
        actions: []
    }
    return item;
}


export class ClientDocImportRunService extends BaseClientService implements DataController<DocImportRun> {

    private _service: DocImportRunService;


    constructor() {
        super();
        this._service = new DocImportRunService({
            apiService: this.apiService,
            url: this.settings.docChatServer
        });
    }


    public async get(options: DocImportRunOptions): Promise<ResultData<DocImportRun>> {

        return await this._service.get(this.buildFetchParams(options), this.token, options.bidId, options.status?.join(","));

    }
    public async getLookup(options: DocImportRunOptions): Promise<ResultData<DocImportRun>> {
        let fetchParams = this.buildLookupFetchParams(options);
        let data = await this._service.get(fetchParams, this.token);
        return data;
    }

    public async getById(options: DocImportRunOptions): Promise<DocImportRun | null> {
        if (options.id) {
            let item = await this._service.getById(options.id, this.token);
            return item;
        }
        return null;
    }
    public async delete(options: DocImportRunOptions): Promise<any> {
        if (options.id)
            await this._service.delete(options.id, this.token);
    }
}